var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 567.3 170",
    style: {
      enableBackground: "new 0 0 567.3 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#812B8E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,104.6V87.6h30.6V76.7H67.8V61.1h34.5V50.3H64.1c-4.4,0-8,3.6-8,8v49.3c0,4.4,3.6,8,8,8h39.9v-10.9H67.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.5,69.5c0.1,4.4,2.5,6.2,12.2,7.2c15.4,1.4,24.3,4.2,24.4,19c0.1,14-12.1,19.9-24.6,19.9c0,0,0,0,0,0 h-23.2V105h23.2c0,0,0,0,0,0c6.3-0.1,13.4-2.4,13.4-9.4c0-5.5-3.3-7.8-13.7-8.8c-11-0.9-21.8-3.7-22.8-15.7 c-0.1-0.6-0.1-1.1-0.1-1.7c0-0.7,0-1.4,0.1-2.1c1-11.7,10.9-17,22.3-17c0.1,0,0.2,0,0.3,0h25.2v10.5h-25.2 C134.6,60.8,127.5,62.4,127.5,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.9,69.5c0.1,4.4,2.5,6.2,12.2,7.2c15.4,1.4,24.3,4.2,24.4,19c0.1,14-12.1,19.9-24.6,19.9c0,0,0,0,0,0 h-23.2V105h23.2c0,0,0,0,0,0c6.3-0.1,13.4-2.4,13.4-9.4c0-5.5-3.3-7.8-13.7-8.8c-11-0.9-21.8-3.7-22.8-15.7 c-0.1-0.6-0.1-1.1-0.1-1.7c0-0.7,0-1.4,0.1-2.1c1-11.7,10.9-17,22.3-17c0.1,0,0.2,0,0.3,0h25.2v10.5h-25.2 C482,60.8,474.9,62.4,474.9,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.8,105.8c6.4,0,11.1-1.2,14.5-3V89.6H204V79.2h24.9v30.6c-9,5.6-16.6,6.9-26.1,6.9 c-20.1,0-28.8-13.4-28.8-33.8c0-20.3,8.7-33.8,28.8-33.8c16.7,0,25.1,8.1,26.4,20.7L217.4,71c-1.2-7.8-5.9-11-14.6-11 C189.4,60,186,70.7,186,82.9C186,95,189.4,105.8,202.8,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.3,107.5V58.2c0-4.4,3.6-8,8-8h20c8.3,0,19.4,3,19.4,18.1c0,6.8-2.9,11-5.9,13c4.6,1.9,8,7.3,8,15.1 c0,15.9-10,19.1-21.1,19.1h-20.4C266.9,115.5,263.3,111.9,263.3,107.5z M275,61.1v15.6h15.4c5,0,8.2-1.5,8.2-7.9 c0-6.3-3.1-7.6-8.2-7.6H275z M291.1,104.6c3.8,0,9.7-0.5,9.7-8.4c0-7.9-5.1-8.7-9.4-8.7H275v17.1H291.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.1,115.5h-11.7V50.3h11.7V115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.2,115.5h-11.7V61.1h-19V50.3h49.7v10.9h-19V115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M449.7,50.3v10.9h-34.5v15.6h30.6v10.9h-30.6v17.1h36.1v10.9h-39.9c-4.4,0-8-3.6-8-8V58.2c0-4.4,3.6-8,8-8 H449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.9,82.9c-0.1,0-0.2,0-0.3,0v0H138.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleName);
export default __webpack_public_path__ + "static/media/purple_name.bdbcc32f671e94ccc918c8e99eeaa922.svg";
export { ForwardRef as ReactComponent };